export const internalLinkRefName = 'internalLinkRef';

export const internalLinkRefProjection = `{
  _id,
  currentPathname,
}`;

export const internalLinkRefQuery = groq`*[_id == $_id][0] ${internalLinkRefProjection}`;
